import React from 'react';
import { Link } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  FileText,
  Gift,
  CreditCard,
  BarChart3,
  Settings,
  FileSearch,
  X,
  UserPlus
} from 'lucide-react';

const Sidebar = ({ isOpen, onClose, currentPath }) => {
  const menuItems = [
    {
      path: '/dashboard',
      icon: LayoutDashboard,
      label: 'Dashboard',
      description: 'Overview and statistics'
    },
    {
      path: '/users',
      icon: Users,
      label: 'User Management',
      description: 'Manage user accounts'
    },
    {
      path: '/surveys',
      icon: FileText,
      label: 'Survey Management',
      description: 'Manage surveys and responses'
    },
    {
      path: '/rewards',
      icon: Gift,
      label: 'Rewards Management',
      description: 'Manage rewards and points'
    },
    {
      path: '/withdrawals',
      icon: CreditCard,
      label: 'Withdrawal Management',
      description: 'Process withdrawal requests'
    },
    {
      path: '/clients',
      icon: UserPlus,
      label: 'Manage Clients',
      description: 'S2S API clients & tokens'
    },
    {
      path: '/settings',
      icon: Settings,
      label: 'System Settings',
      description: 'Configure system settings'
    },

  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:flex-shrink-0 lg:fixed lg:inset-y-0 lg:left-0 lg:z-30 sidebar-wrapper">
        <div className="flex flex-col w-72 border-r border-gray-200">
          <div className="flex flex-col flex-grow bg-white pt-4 pb-4 overflow-y-auto">
            {/* Logo Only */}
            <div className="flex items-center justify-center flex-shrink-0 px-4 py-4">
              <Link
                to="/dashboard"
                className="sidebar-brand flex items-center bg-white px-3 py-2 rounded-2xl border border-gray-200 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-opacity-50"
                aria-label="Elcid Research - Go to admin dashboard"
              >
                <img
                  src="/erasebg-elicit.png"
                  alt="Elcid Research Logo"
                  className="h-12 sm:h-14 w-auto transition-transform duration-200 ease-out"
                  onError={(e) => { e.currentTarget.src = '/elcid-removebg-preview.png'; }}
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="mt-4 flex-1 px-2 admin-nav-container">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = currentPath === item.path;

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`group flex items-center px-3 py-2 text-sm font-medium rounded-xl transition-all duration-200 admin-touch-target ${isActive ? 'admin-nav-item-active' : 'admin-nav-item'}`}
                  >
                    <Icon className={`admin-nav-icon mr-3 h-4 w-4 flex-shrink-0`} />
                    <div className="flex-1 min-w-0">
                      <div className="text-xs font-medium truncate">{item.label}</div>
                      <div className={`admin-nav-desc text-[10px] mt-0.5 truncate hidden group-hover:block`}>
                        {item.description}
                      </div>
                    </div>
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className={`lg:hidden fixed inset-y-0 left-0 z-40 w-full max-w-xs sm:max-w-sm bg-white border-r border-gray-200 transition-transform duration-300 ease-in-out sidebar-wrapper ${isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}>
        <div className="flex flex-col h-full">
          {/* Mobile Header */}
          <div className="flex items-center justify-between flex-shrink-0 px-4 py-4">
            <div className="flex items-center justify-center flex-1">
              <Link
                to="/dashboard"
                className="sidebar-brand flex items-center bg-white px-3 py-2 rounded-2xl border border-gray-200 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-opacity-50"
                aria-label="Elcid Research - Go to admin dashboard"
                onClick={onClose}
              >
                <img
                  src="/erasebg-elicit.png"
                  alt="Elcid Research Logo"
                className="h-12 sm:h-14 w-auto transition-transform duration-200 ease-out"
                  onError={(e) => { e.currentTarget.src = '/elcid-removebg-preview.png'; }}
                />
              </Link>
            </div>
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-emerald-700 p-2 rounded-lg hover:bg-emerald-50 transition-all duration-200"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Mobile Navigation */}
          <nav className="flex-1 px-3 pb-4 admin-spacing-xs">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPath === item.path;

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={onClose}
                  className={`group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 admin-touch-target ${isActive ? 'admin-nav-item-active' : 'admin-nav-item'}`}
                >
                  <Icon className={`admin-nav-icon mr-4 h-5 w-5 flex-shrink-0`} />
                  <div className="flex-1 min-w-0">
                    <div className="text-xs font-medium truncate">{item.label}</div>
                    <div className="hidden"></div>
                  </div>
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
